import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MonitorCard from 'components/Dashboard/MonitorCard';
import TableComponent from 'components/common/TableComponent';
import { useTableData } from 'hooks/useTableData';

const DataSection = ({ data, dates, type, title, color }) => {
  const { t } = useTranslation();
  // Dynamically construct the data keys based on type
  const dataYesterday = data[`${type}DataYesterday`] || [];
  const dataToday = data[`${type}DataToday`] || [];
  const dataLast7Days = data[`${type}DataLast7Days`] || [];
  const dataLast30Days = data[`${type}DataLast30Days`] || [];

  const yesterdayTableData = useTableData(dataYesterday, type);
  const todayTableData = useTableData(dataToday, type);
  const last7DaysTableData = useTableData(dataLast7Days, type);
  const last30DaysTableData = useTableData(dataLast30Days, type);

  return (
    <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div className="h-full">
        <MonitorCard
          title={title}
          color={color}
          date={`${t('dashboard.previousDay')} (${dates.previousDate})`}
          hasData={yesterdayTableData.rows.length > 0}
          showFilterBtn={false}
        >
          <div className="text-xs">
            <TableComponent
              tableData={yesterdayTableData}
              defaultSortColumn={yesterdayTableData.columns[0]?.key}
            />
          </div>
        </MonitorCard>
      </div>

      <div className="h-full">
        <MonitorCard
          title={title}
          color={color}
          date={`${t('dashboard.today')} (${dates.currentDate})`}
          hasData={todayTableData.rows.length > 0}
          showFilterBtn={false}
        >
          <div className="text-xs">
            <TableComponent
              tableData={todayTableData}
              defaultSortColumn={todayTableData.columns[0]?.key}
            />
          </div>
        </MonitorCard>
      </div>

      <div className="h-full">
        <MonitorCard
          title={title}
          color={color}
          date={`${t('dashboard.last7Days')} (${dates.last7DaysRange})`}
          hasData={last7DaysTableData.rows.length > 0}
          showFilterBtn={false}
        >
          <div className="text-xs">
            <TableComponent
              tableData={last7DaysTableData}
              defaultSortColumn={last7DaysTableData.columns[0]?.key}
            />
          </div>
        </MonitorCard>
      </div>

      <div className="h-full">
        <MonitorCard
          title={title}
          color={color}
          date={`${t('dashboard.last30Days')} (${dates.last30DaysRange})`}
          hasData={last30DaysTableData.rows.length > 0}
          showFilterBtn={false}
        >
          <div className="text-xs">
            <TableComponent
              tableData={last30DaysTableData}
              defaultSortColumn={last30DaysTableData.columns[0]?.key}
            />
          </div>
        </MonitorCard>
      </div>
    </div>
  );
};

DataSection.propTypes = {
  data: PropTypes.object,
  dates: PropTypes.shape({
    previousDate: PropTypes.string,
    currentDate: PropTypes.string,
    last7DaysRange: PropTypes.string,
    last30DaysRange: PropTypes.string
  }),
  type: PropTypes.string,
  title: PropTypes.string,
  color: PropTypes.string
};

export default DataSection;
